import { ImageNodeAttrs } from 'common/Prose/nodeViews/Image/Types'
import { Button } from 'blaze-ui/Button'
import { ArrowSwitchVertical } from 'blaze-ui/icons'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { useCreateMediaObjects } from 'hooks/queries/mediaObjects/useCreateMediaObjects'
import { replaceImageWithImages } from 'common/Prose/nodeViews/Image/utils'
import { useDocStore } from 'stores/DocStore'
import { EditorView } from 'prosemirror-view'
import { reportError } from 'utils/error'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { downloadFile } from './utils'

interface Props extends Omit<ButtonProps, 'onPress' | 'children'> {
  url: string
  attrs: ImageNodeAttrs
  view: EditorView
}

export const ReplaceImageButton = ({
  url,
  size = 'sm',
  frontIcon = ArrowSwitchVertical,
  variant = 'primary',
  isDisabled = false,
  attrs,
  view,
  ...buttonProps
}: Props) => {
  const { mutateAsync: createMediaObjects, isLoading } = useCreateMediaObjects()
  const docStore = useDocStore()
  const { imageStores } = docStore
  const imageStore = imageStores.get(attrs.blockId)

  const handlePress = async () => {
    try {
      const file = await downloadFile(url, attrs.description)
      const mediaObjects = await createMediaObjects([{ file, filename: file.name }])
      replaceImageWithImages(
        view,
        attrs,
        mediaObjects.map((mediaObject) => ({
          url: mediaObject.source_url,
        })),
      )
      if (imageStore) {
        imageStore.clearVariants()
      }
    } catch (e) {
      reportError(e)
      showErrorMessageToast('There was an error replacing this image. Please try again.')
    }
  }

  return (
    <Button
      variant={variant}
      size={size}
      frontIcon={frontIcon}
      isDisabled={isLoading || isDisabled}
      {...buttonProps}
      onPress={handlePress}
      aria-label="Replace Image"
    >
      Replace
    </Button>
  )
}
